import { useUI } from "providers/UIProvider"
import { Box, Flex, Text } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import Input from "components/UI/atoms/Input"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import Tabs from "components/UI/molecules/Tabs"
import { REFUND_TABS } from "types/shared"
import useRefund from "hooks/useRefund"
import { useTransactionsContext } from "providers/TransactionsProvider/TransactionsProvider"

const RefundModal = () => {
  const { modals, toggleModal, T } = useUI()
  const { form: { values, errors, touched, handleChange, handleBlur, handleSubmit }, currentTab, handleTabChange } = useRefund()
  const { refundTransactionLoading } = useTransactionsContext()
  const refundModalData = modals.refundModal.data

  const isPartly = currentTab === REFUND_TABS.PARTLY

  return (
    <Modal
      isOpen={modals.refundModal.isOpened}
      onClose={() => toggleModal("refundModal", false)}
      title={T("refund_modal.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "549px",
        bodyPadding: "25px 25px 48px 25px",
      }}
    >
    <Flex justifyContent={"center"} alignItems="center" flexDirection={"column"}>
        <Flex padding={"20px 14px"} mb={"28px"} justifyContent={"space-between"} alignItems="center"  height="60px" backgroundColor="#E9F2FD" borderRadius={"20px"} >
            <Text fontWeight="600" fontSize="m" mr="20px">
                  {refundModalData?.bankTransactionId || "-"}
            </Text>
            <Flex padding={"20px"} alignItems={"center"} justifyContent="center" w="68px" h="32px" border="1px solid #08BA36" borderRadius={"16px"}>
                <Text color={"#08BA36"} fontSize="xl" >{refundModalData?.price || "-"}₾</Text>
            </Flex>
        </Flex>
        <Tabs
            items={[
              {
                key: REFUND_TABS.PARTLY,
                value: T("refund_modal.tabs.partial"),
                valueIcon: "bookingFee"
              },
              {
                key: REFUND_TABS.FULLY,
                value: T("refund_modal.tabs.fully"),
                valueIcon: "currency_GEL",
                renderContent: true,
                content: "₾"
              }
            ]}
            currentTab={currentTab}
            handleTabChange={handleTabChange}
          />  
          {isPartly && (
            <Box mt={"25px"}>
              <Text mb={"3px"} fontSize="12px" color={"black"} opacity={0.7}>{T("refund.form.amount_label")} (₾) </Text>
              <Input
                id="amount"
                styles={{
                    width: "304px",
                    height: "50px",
                }}
                name="amount"
                value={values.amount}
                onChange={handleChange}
                onBlur={handleBlur}
                type="number"
                error={Boolean(errors.amount && touched.amount)}
                errorMessage={errors.amount}
              />
            </Box>
          )}
          <Box mt="30px">
          <Button
             _hover={{ backgroundColor: "#08BA36" }} 
            isLoading={refundTransactionLoading}
            isDisabled={refundTransactionLoading}
            text={`${isPartly ? T("actions.confirm") : T("refund.form.full_refund_button")}`} 
            onClick={handleSubmit} 
            variant="success" 
            styles={{ width: "280px", height: "80px", fontSize: "18px" }}
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{
                  width: "34px",
                  height: "34px",
                  fill: "white",
                }}
              />
            }
          />
          </Box>
    </Flex>
      
    </Modal>
  )
}

export default RefundModal
